import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import Root from './root';

ReactDOM.render(<Root />,
  document.querySelector('#root'));
